import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { InitialState, VatInfoState } from './types'
import { RootState } from '@/store/types';

const namespaced: boolean = true

export const vatInfo: Module<VatInfoState, RootState> = {
  namespaced,
  state: InitialState,
  getters,
  actions,
  mutations
}
